module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.staffName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所在部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.staffDeptName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("行政级别")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.rankName))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("申请信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请加班处理")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.overtimeTypeName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("加班天数")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.overtimeDays))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请加班时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.overtimeTime))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("加班事由")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.overtimeReason))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("备注")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.remark))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d27228a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/todo/attendance/overtime.vue
// module id = SMK2
// module chunks = 0